module.exports = __webpack_public_path__ + "static/media/sidebar-2.098ba1b2.jpg";